var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23.5,
    stroke: "url(#paint0_linear_147_226)",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 8,
    width: 28,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6582 8.96167L11.8633 30.2048L21.2239 37.6053L38.0188 16.3622L28.6582 8.96167Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5726 25.5847C17.4197 23.2483 20.6835 22.6863 23.1876 24.1399L32.1519 12.8013C32.4417 12.4348 32.9742 12.3727 33.3405 12.6623C33.7069 12.9521 33.7691 13.4846 33.4795 13.8509L32.9547 14.5146L34.9461 16.0891C35.3126 16.3788 35.3747 16.9113 35.0851 17.2776C34.7954 17.6441 34.2629 17.7062 33.8966 17.4166L31.9051 15.8421L30.8555 17.1698L31.5192 17.6946C31.8857 17.9843 31.9478 18.5168 31.6582 18.8831C31.3685 19.2496 30.836 19.3117 30.4697 19.0221L29.8059 18.4973L24.5155 25.1889C26.5074 27.2902 26.7139 30.5954 24.8667 32.9318C22.8408 35.4943 19.1082 35.9308 16.5458 33.9049C13.983 31.8796 13.5463 28.1471 15.5724 25.5844L15.5726 25.5847ZM23.5388 31.8828C24.9857 30.0526 24.674 27.3865 22.8438 25.9395C21.0135 24.4925 18.3474 24.8042 16.9004 26.6345C15.4534 28.4647 15.7652 31.1308 17.5954 32.5778C19.4257 34.0248 22.0918 33.7131 23.5388 31.8828Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_226",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C245B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F508C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordIcon);
export default __webpack_public_path__ + "static/media/forgotPasswordIcon.d186ecd8b3b854fcb39a93b7607d9896.svg";
export { ForwardRef as ReactComponent };